// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media screen and (min-width:950px){
    .root-user-system-administrators-page{
        margin: 0px;
        padding: 0px;
        height: 100vh;
        box-sizing: border-box;
        font-family:Verdana, Geneva, Tahoma, sans-serif;
    }
    .root-user-system-administrators-page-layout{
        height: 90%;
        box-sizing: border-box;
        display: grid;
        grid-template-columns: auto 1fr;
    }
    .root-user-system-administrators-parent-container{
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .root-user-system-administrators-container{
        width: 90%;
        height: 85%;
        padding: 2% 3%;
        border-radius: 5px;
        position: relative;
        box-shadow: 0 0 8px rgba(0, 0, 0, 0.2);
    }
    .root-user-system-administrators-header-container{
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .root-user-system-administrators-header-container h2{
        margin-left: 15px;
        font-size: 16px;
        font-weight: lighter;
        color: rgb(90, 90, 90);
    }
    .root-user-system-administrators-header-controls{
        display: flex;
        align-items: center;
    }
    .root-user-add-new-system-administrator-button{
        background-color: transparent;
        border: none;
        cursor: pointer;
        border-radius: 50%;
        padding: 2px 4px;
    }
    .root-user-add-new-system-administrator-button:hover{
        background-color: rgb(214, 214, 214);
    }
    .root-user-add-new-system-administrator-button img{
        height: 30px;
    }

    .root-user-loading-system-administrators-parent-container{
        height: 80%;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .root-user-loading-system-administrators-container{
        text-align: center;
    }
    .root-user-loading-system-administrators-container div{
        width: 32px;
        height: 32px;
        display: inline-block;
        border-radius: 50%;
        border: 2px solid brown;
        border-top-color: transparent;
        animation: root-user-loading-system-administrators-spinner 0.8s linear infinite;
    }
    @keyframes root-user-loading-system-administrators-spinner {
        from{
            transform: rotate(0deg);
        }
        to{
            transform: rotate(360deg);
        }
    }
    .root-user-loading-system-administrators-container p{
        font-size: 15px;
        color: rgb(71, 71, 71);
        font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    }

    .root-user-system-administrators-unavailable-container{
        margin-bottom: 10vh;
        padding: 12px 28px;
        border-radius: 4px;
        box-shadow: 0px 8px 8px 0px rgba(0, 0, 0, 0.1);
    }
    .root-user-system-administrators-unavailable-container h2{
        margin: 5px 0px;
        font-weight: 500;
        font-size: 20px;
        color: rgb(85, 85, 85);
        font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    }
    .root-user-system-administrators-unavailable-container p{
        margin: 12px 0px;
        font-size: 15px;
        color: rgb(56, 56, 56);
    }
    .root-user-system-administrators-unavailable-container div{
        text-align: right;
        padding: 5px 0px;
    }
    .root-user-system-administrators-unavailable-container div button{
        border: none;
        color: white;
        padding: 8px 16px;
        border-radius: 4px;
        cursor: pointer;
        background-color: rgb(48, 105, 152);
        transition: background-color 0.25s ease-in-out;
    }
    .root-user-system-administrators-unavailable-container div button:hover{
        background-color: rgb(35, 85, 125);
    }
    .root-user-system-administrators-table-container table{
        width: 100%;
        table-layout: fixed;
        border-collapse: collapse;
    }
    .root-user-system-administrators-table-container table tr:nth-child(even){
        background-color: rgb(242, 242, 242);
    }
    .root-user-system-administrators-table-container table tr:nth-child(odd){
        background-color: rgba(206, 206, 206, 0.952);
    }
    #root-user-system-administrators-table-header-row{
        background-color: transparent;
    }
    .root-user-system-administrators-table-container table th,
    .root-user-system-administrators-table-container table td{
        text-align: left;
        font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    }
    .root-user-system-administrators-table-container table th:last-child,
    .root-user-system-administrators-table-container table td:last-child{
        width: 10%;
    }
    .root-user-system-administrators-table-container table th{
        cursor: default;
        font-weight: 500;
        padding: 10px 5px;
    }
    .root-user-system-administrators-table-container table td{
        font-size: 15px;
        cursor: pointer;
        padding: 4px 5px;
    }
    .root-user-system-administrators-table-container table td img{
        height: 20px;
        margin-top: 2px;
        margin-right: 20px;
    }
}`, "",{"version":3,"sources":["webpack://./src/styles/workspace_styles/RootUserStyles/SystemAdministrators/SystemAdministrators.css"],"names":[],"mappings":"AAAA;IACI;QACI,WAAW;QACX,YAAY;QACZ,aAAa;QACb,sBAAsB;QACtB,+CAA+C;IACnD;IACA;QACI,WAAW;QACX,sBAAsB;QACtB,aAAa;QACb,+BAA+B;IACnC;IACA;QACI,aAAa;QACb,mBAAmB;QACnB,uBAAuB;IAC3B;IACA;QACI,UAAU;QACV,WAAW;QACX,cAAc;QACd,kBAAkB;QAClB,kBAAkB;QAClB,sCAAsC;IAC1C;IACA;QACI,WAAW;QACX,aAAa;QACb,8BAA8B;QAC9B,mBAAmB;IACvB;IACA;QACI,iBAAiB;QACjB,eAAe;QACf,oBAAoB;QACpB,sBAAsB;IAC1B;IACA;QACI,aAAa;QACb,mBAAmB;IACvB;IACA;QACI,6BAA6B;QAC7B,YAAY;QACZ,eAAe;QACf,kBAAkB;QAClB,gBAAgB;IACpB;IACA;QACI,oCAAoC;IACxC;IACA;QACI,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,aAAa;QACb,mBAAmB;QACnB,uBAAuB;IAC3B;IACA;QACI,kBAAkB;IACtB;IACA;QACI,WAAW;QACX,YAAY;QACZ,qBAAqB;QACrB,kBAAkB;QAClB,uBAAuB;QACvB,6BAA6B;QAC7B,+EAA+E;IACnF;IACA;QACI;YACI,uBAAuB;QAC3B;QACA;YACI,yBAAyB;QAC7B;IACJ;IACA;QACI,eAAe;QACf,sBAAsB;QACtB,4DAA4D;IAChE;;IAEA;QACI,mBAAmB;QACnB,kBAAkB;QAClB,kBAAkB;QAClB,8CAA8C;IAClD;IACA;QACI,eAAe;QACf,gBAAgB;QAChB,eAAe;QACf,sBAAsB;QACtB,4DAA4D;IAChE;IACA;QACI,gBAAgB;QAChB,eAAe;QACf,sBAAsB;IAC1B;IACA;QACI,iBAAiB;QACjB,gBAAgB;IACpB;IACA;QACI,YAAY;QACZ,YAAY;QACZ,iBAAiB;QACjB,kBAAkB;QAClB,eAAe;QACf,mCAAmC;QACnC,8CAA8C;IAClD;IACA;QACI,kCAAkC;IACtC;IACA;QACI,WAAW;QACX,mBAAmB;QACnB,yBAAyB;IAC7B;IACA;QACI,oCAAoC;IACxC;IACA;QACI,4CAA4C;IAChD;IACA;QACI,6BAA6B;IACjC;IACA;;QAEI,gBAAgB;QAChB,4DAA4D;IAChE;IACA;;QAEI,UAAU;IACd;IACA;QACI,eAAe;QACf,gBAAgB;QAChB,iBAAiB;IACrB;IACA;QACI,eAAe;QACf,eAAe;QACf,gBAAgB;IACpB;IACA;QACI,YAAY;QACZ,eAAe;QACf,kBAAkB;IACtB;AACJ","sourcesContent":["@media screen and (min-width:950px){\n    .root-user-system-administrators-page{\n        margin: 0px;\n        padding: 0px;\n        height: 100vh;\n        box-sizing: border-box;\n        font-family:Verdana, Geneva, Tahoma, sans-serif;\n    }\n    .root-user-system-administrators-page-layout{\n        height: 90%;\n        box-sizing: border-box;\n        display: grid;\n        grid-template-columns: auto 1fr;\n    }\n    .root-user-system-administrators-parent-container{\n        display: flex;\n        align-items: center;\n        justify-content: center;\n    }\n    .root-user-system-administrators-container{\n        width: 90%;\n        height: 85%;\n        padding: 2% 3%;\n        border-radius: 5px;\n        position: relative;\n        box-shadow: 0 0 8px rgba(0, 0, 0, 0.2);\n    }\n    .root-user-system-administrators-header-container{\n        width: 100%;\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n    }\n    .root-user-system-administrators-header-container h2{\n        margin-left: 15px;\n        font-size: 16px;\n        font-weight: lighter;\n        color: rgb(90, 90, 90);\n    }\n    .root-user-system-administrators-header-controls{\n        display: flex;\n        align-items: center;\n    }\n    .root-user-add-new-system-administrator-button{\n        background-color: transparent;\n        border: none;\n        cursor: pointer;\n        border-radius: 50%;\n        padding: 2px 4px;\n    }\n    .root-user-add-new-system-administrator-button:hover{\n        background-color: rgb(214, 214, 214);\n    }\n    .root-user-add-new-system-administrator-button img{\n        height: 30px;\n    }\n\n    .root-user-loading-system-administrators-parent-container{\n        height: 80%;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n    }\n    .root-user-loading-system-administrators-container{\n        text-align: center;\n    }\n    .root-user-loading-system-administrators-container div{\n        width: 32px;\n        height: 32px;\n        display: inline-block;\n        border-radius: 50%;\n        border: 2px solid brown;\n        border-top-color: transparent;\n        animation: root-user-loading-system-administrators-spinner 0.8s linear infinite;\n    }\n    @keyframes root-user-loading-system-administrators-spinner {\n        from{\n            transform: rotate(0deg);\n        }\n        to{\n            transform: rotate(360deg);\n        }\n    }\n    .root-user-loading-system-administrators-container p{\n        font-size: 15px;\n        color: rgb(71, 71, 71);\n        font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n    }\n\n    .root-user-system-administrators-unavailable-container{\n        margin-bottom: 10vh;\n        padding: 12px 28px;\n        border-radius: 4px;\n        box-shadow: 0px 8px 8px 0px rgba(0, 0, 0, 0.1);\n    }\n    .root-user-system-administrators-unavailable-container h2{\n        margin: 5px 0px;\n        font-weight: 500;\n        font-size: 20px;\n        color: rgb(85, 85, 85);\n        font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n    }\n    .root-user-system-administrators-unavailable-container p{\n        margin: 12px 0px;\n        font-size: 15px;\n        color: rgb(56, 56, 56);\n    }\n    .root-user-system-administrators-unavailable-container div{\n        text-align: right;\n        padding: 5px 0px;\n    }\n    .root-user-system-administrators-unavailable-container div button{\n        border: none;\n        color: white;\n        padding: 8px 16px;\n        border-radius: 4px;\n        cursor: pointer;\n        background-color: rgb(48, 105, 152);\n        transition: background-color 0.25s ease-in-out;\n    }\n    .root-user-system-administrators-unavailable-container div button:hover{\n        background-color: rgb(35, 85, 125);\n    }\n    .root-user-system-administrators-table-container table{\n        width: 100%;\n        table-layout: fixed;\n        border-collapse: collapse;\n    }\n    .root-user-system-administrators-table-container table tr:nth-child(even){\n        background-color: rgb(242, 242, 242);\n    }\n    .root-user-system-administrators-table-container table tr:nth-child(odd){\n        background-color: rgba(206, 206, 206, 0.952);\n    }\n    #root-user-system-administrators-table-header-row{\n        background-color: transparent;\n    }\n    .root-user-system-administrators-table-container table th,\n    .root-user-system-administrators-table-container table td{\n        text-align: left;\n        font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n    }\n    .root-user-system-administrators-table-container table th:last-child,\n    .root-user-system-administrators-table-container table td:last-child{\n        width: 10%;\n    }\n    .root-user-system-administrators-table-container table th{\n        cursor: default;\n        font-weight: 500;\n        padding: 10px 5px;\n    }\n    .root-user-system-administrators-table-container table td{\n        font-size: 15px;\n        cursor: pointer;\n        padding: 4px 5px;\n    }\n    .root-user-system-administrators-table-container table td img{\n        height: 20px;\n        margin-top: 2px;\n        margin-right: 20px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
